import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useRenumerationModal } from '../context/RenumerationModalContext';
import RenumerationScriptureView from './RenumerationScriptureView';
import RenumerationMovementsView from './RenumerationMovemenstView';

const RenumerationModalBody: FC = () => {
  const { data } = useRenumerationModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <RenumerationScriptureView />
        ) : (
          <RenumerationMovementsView />
        )}
      </div>
    </Modal.Body>
  );
};

export default RenumerationModalBody;
